import React, {useState} from "react";
import {Input, message} from "antd";
import {Link} from "react-router-dom";
import config from "@/config";

export const ConfirmUsername = ({setStep, user}) => {

    const [username, setUsername] = useState("");

    const handleConfirmUsername = () => {
        // FAKE API
        if (username === user.username) {
            setStep(2);
        } else {
            message.error("Tài khoản không tồn tại");
        }
    }

    return (
        <>
            <div className="space-y-3">
                <div className={"space-y-2"}>
                    <label className={"block text-sm font-medium"}>Nhập tên tài khoản của bạn<span
                        className={"text-red-500"}>*</span></label>
                    <Input className={"w-full"} placeholder="Nhập tài khoản đăng nhập của bạn"
                           onChange={(e) => setUsername(e.target.value)}/>
                </div>
                <div className={"flex justify-center"}>
                    <button
                        onClick={handleConfirmUsername}
                        className="px-6 py-2 w-1/2 bg-black text-white rounded-md font-semibold hover:bg-gray-800"
                    >
                        Xác nhận
                    </button>
                </div>
            </div>

            <div className="text-center mt-4">
                <p className="text-gray-600">Quay lại trang đăng nhập?{' '}
                    <Link to={config.routes.login} className="text-blue-500 hover:text-blue-400 font-semibold">
                        Đăng nhập
                    </Link>
                </p>
            </div>
        </>
    )
}